import { SkinTones } from 'emoji-picker-react';
import { createRef } from 'react';
import { eFieldTypes } from './Agenda.enums';
import {
  tAgendaContext,
  tAgendaEventsContext,
  tAgendaTemplateField,
  tAgendaTemplatesContext,
} from './Agenda.types';
import {
  eAgendaTabs,
  eCalendarView,
} from './components/Calendar/Calendar.enums';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from '../../lib/logging';

export const DEFAULT_EMOJI = {
  activeSkinTone: SkinTones.NEUTRAL,
  emoji: '☎️',
  getImageUrl: (): string => '',
  imageUrl:
    'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/260e-fe0f.png',
  isCustom: false,
  names: ['phone', 'telephone', 'black telephone'],
  unified: '260e-fe0f',
  unifiedWithoutSkinTone: '260e-fe0f',
};

export const initialAgendaState: tAgendaContext = {
  setCurrentTab: () => false,
  currentTab: eAgendaTabs.EVENTS,
  currentTemplates: null,
  setCurrentTemplates: () => false,
  deleteTemplate: async () => {},
  currentEventTypes: null,
  currentEvents: null,
  setCurrentEvents: () => false,
  getCurrentEvent: () => undefined,
  getCurrentEventType: () => undefined,
  selectedLead: null,
  setSelectedLead: () => {},
};

export const initialAgendaEventState: tAgendaEventsContext = {
  showEventsModal: false,
  toggleEventsModal: () => false,
  loadingEventRequest: false,
  setLoadingEventRequest: () => false,
  editionMode: false,
  setEditionMode: () => false,
  EventManagementFormikOptions: {
    initialValues: {
      selectedTemplate: '',
      eventTitle: '',
      date: new Date(),
      time: new Date(),
      description: '',
      duration: '',
      address: '',
      links: '',
      users: [],
      notes: '',
    },
    validationSchema: {},
    onSubmit: () =>
      LLog.info(
        {
          component: LOG_COMPONENTS.UI,
          method: 'Agenda.constants',
          operation: LOG_OPERATIONS.UI_INTERACTION,
        },
        'Create button clicked',
      ),
  },
  eventManagementModalRef: createRef(),
  setSelectedTemplate: () => null,
  currentTemplateFields: {},
  submitTemplateForm: () => null,
  fieldsMissingError: false,
  userOptions: [],
  editEvent: () => null,
  openEventCreationModal: () => null,
  openTemplateTab: () => null,
};

export const initialTemplateState: tAgendaTemplatesContext = {
  showTemplateModal: false,
  toggleTemplateModal: () => false,
  isTemplateEditionMode: false,
  TemplateManagementFormikOptions: {
    initialValues: {
      templateTitle: '',
      eventType: 'call',
      reminderMinutes: 0,
    },
    onSubmit: () => {},
  },
  selectedEmoji: DEFAULT_EMOJI.unified,
  setSelectedEmoji: () => false,
  creatingTemplate: false,
  currentTemplateFields: {},
  editTemplate: () => false,
  deleteTemplate: async () => {},
  openTemplateCreationModal: () => false,
  setCurrentTemplateFields: () => false,
};

export const AGENDA_VIEW_TABS = [
  {
    selectedTab: eAgendaTabs.EVENTS,
    title: 'Lista',
    view: eCalendarView.LIST_DAY,
  },
  {
    selectedTab: eAgendaTabs.CALENDAR,
    title: 'Calendario',
    view: eCalendarView.DAY_GRID_MONTH,
  },
  {
    selectedTab: eAgendaTabs.TEAM,
    title: 'Equipo',
    view: eCalendarView.RESOURCE_TIME_GRID_DAY,
  },
];

export const AGENDA_TEMPLATE_CREATION_TAB = {
  selectedTab: eAgendaTabs.TEMPLATES,
  title: 'Templates',
};

export const AGENDA_REMINDER_FIELD: tAgendaTemplateField = {
  nameTag: '¿Enviar recordatorio?',
  name: 'reminder',
  type: eFieldTypes.NUMBER,
  required: true,
  eventLabel: 'Agrega una descripción',
  placeHolder: 'Ej. Llamar al cliente importante',
};

export const TEMPLATE_MODAL_SECTION_1: tAgendaTemplateField[] = [
  {
    nameTag: '¿Solicitar descripción del evento?',
    name: 'description',
    type: eFieldTypes.STRING,
    required: true,
    eventLabel: 'Agrega una descripción',
    placeHolder: 'Ej. Llamar al cliente importante',
  },
  {
    nameTag: '¿Solicitar dirección?',
    name: 'address',
    type: eFieldTypes.STRING,
    required: true,
    eventLabel: 'Agrega una dirección',
    placeHolder: 'Ej. Av. Insurgentes Sur 1234',
  },
];

export const TEMPLATE_MODAL_SECTION_2: tAgendaTemplateField[] = [
  {
    nameTag: 'Permitir agregar links',
    name: 'links',
    type: eFieldTypes.LINKS,
    required: true,
    eventLabel: '¿Quieres agregar un link?',
    placeHolder: 'Ej. https://leadsales.com',
  },
  {
    nameTag: 'Permitir agregar notas',
    name: 'notes',
    type: eFieldTypes.STRING,
    required: true,
    eventLabel: '¿Quieres agregar notas?',
    placeHolder: 'Ej. No olvides llevar el contrato',
  },
  {
    nameTag: 'Permitir agregar invitados',
    name: 'users',
    type: eFieldTypes.USERS,
    required: true,
  },
];
